export default __webpack_public_path__ + "static/media/9.150064c5.png";